import { EventTeam } from '@domain/eventTeam';
import { useGenericQuery } from '@hooks/use-generic-query';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

const getEventChannelsById = async (eventId?: string) => {
  if (!eventId) return null;
  const url = `${import.meta.env.VITE_EVENTS_HOST}/v1/nightgraph/events/${eventId}/teams`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetEventTeamChannels = ({
  eventId,
  options,
}: {
  eventId?: string;
  options?: Record<string, boolean | number>;
}) => {
  return useGenericQuery<EventTeam, RequestError>(
    ['event-team-channels', eventId],
    () => getEventChannelsById(eventId),
    {
      ...options,
    }
  );
};
